module.exports = __webpack_public_path__ + "static/img/protect.661b74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/protect.png
// module id = 4UJq
// module chunks = 192